<template>
  <article class="col-md-18">
    <h1>Rateplan</h1>
    <form novalidate>
      <div class="form-group row">
        <label for="displayName" class="col">Name:</label>
        <input
          type="text"
          class="form-control col col-12"
          :class="{
            'is-invalid': $v.plan.displayName.$error,
          }"
          id="displayName"
          v-model="plan.displayName"
          @change="$v.plan.displayName.$touch()"
        />
      </div>

      <div class="form-group row">
        <label for="commPlan" class="col">Communication plan:</label>
        <input
          type="text"
          class="form-control col col-12"
          :class="{
            'is-invalid': $v.plan.commPlan.$error,
          }"
          id="commPlan"
          v-model="plan.commPlan"
          @change="$v.plan.commPlan.$touch()"
        />
      </div>

      <div class="form-group row">
        <label for="jasperWirelessCode" class="col"
          >Jasper wireless code:</label
        >
        <input
          type="text"
          class="form-control col col-12"
          :class="{
            'is-invalid': $v.plan.jasperWirelessCode.$error,
          }"
          id="jasperWirelessCode"
          v-model="plan.jasperWirelessCode"
          @change="$v.plan.jasperWirelessCode.$touch()"
        />
      </div>

      <div class="form-group row">
        <label for="enabled" class="col">Enabled:</label>
        <div class="col col-12 pl-4">
          <input
            type="checkbox"
            class="form-check-input"
            id="enabled"
            v-model="plan.enabled"
          />
        </div>
      </div>
      <button
        type="submit"
        @click.prevent="save(plan)"
        class="btn btn-sm btn-primary mr-2"
      >
        Save
      </button>
    </form>

    <router-link class="btn btn-secondary mt-3" to="/secure/rateplans/">
      Back to list
    </router-link>
  </article>
</template>

<script>
import axios from 'axios'
import { mapActions } from 'vuex'
import { required, numeric } from 'vuelidate/lib/validators'
import loading from '../mixins/loading'

export default {
  name: 'Rateplans',
  mixins: [loading],
  data() {
    return {
      loading: {
        getRateplan: false,
        save: false,
      },
      plan: {
        id: undefined,
        displayName: '',
        commPlan: undefined,
        jasperWirelessCode: '',
        enabled: true,
      },
    }
  },
  validations: {
    plan: {
      displayName: {
        required,
      },
      commPlan: {
        required,
        numeric,
      },
      jasperWirelessCode: {
        required,
      },
    },
  },
  computed: {
    newRateplan() {
      return this.$route.params.id === 'new'
    },
  },
  methods: {
    ...mapActions('toast', ['addToast']),
    getRateplan(id) {
      this.loading.getRateplan = true
      axios
        .get(`/rest/rateplan/${id}`)
        .then(response => (this.plan = response.data))
        .finally(() => (this.loading.getRateplan = false))
    },
    save() {
      this.$v.plan.$touch()
      if (this.$v.plan.$invalid) {
        return
      }

      this.loading.save = true
      axios(`/rest/rateplan/${this.plan.id || ''}`, {
        method: this.plan.id ? 'PUT' : 'POST',
        data: this.plan,
      })
        .then(response => {
          if (!this.plan.id) {
            this.plan = response.data
          }
          this.$router.push(`/secure/rateplans`)

          this.addToast({
            message: `Rateplan ${this.plan.displayName} saved`,
            type: 'success',
          })
        })
        .finally(() => (this.loading.save = false))
    },
  },
  beforeMount() {
    if (!this.newRateplan) {
      this.getRateplan(this.$route.params.id)
    }
  },
}
</script>

<style lang="scss"></style>
